import React from "react";
import { Route, Routes } from "react-router-dom";
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import Layout from "Layout";
import NonAuthLayout from "Layout/NonLayout";
import AuthProtected from "./AuthProtected";
import { Toaster } from "react-hot-toast";
import { useAuthStore } from "store/useAuthStore";
import Disabled from "pages/Disabled";
import ProfileCreation from "pages/Business/ProfileCreation";


const RouteIndex = () => {
  const { user } = useAuthStore();

  if (user && user.isDisabled) {
    return (
      <Routes>
        <Route path="*" element={<Disabled />} />
      </Routes>
    );
  }

  if (user && user.isBusiness && !user.business) {
    return (
      <Routes>
        <Route path="*" element={<ProfileCreation />} />
      </Routes>
    );
  }

  return (
    <React.Fragment>
      <Toaster />
      <Routes>
        {authProtectedRoutes.map((route: any, idx: number) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <AuthProtected>
                <Layout>
                  <route.component />
                </Layout>
              </AuthProtected>
            }
          />
        ))}
        {publicRoutes.map((route: any, idx: number) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <NonAuthLayout>
                <route.component />
              </NonAuthLayout>
            }
          />
        ))}
      </Routes>
    </React.Fragment>
  );
};

export default RouteIndex;
